<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" :active-tab="activePlatform" @tab-change="switchPlatform">
			<div>
				<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				
			</template>
			<template #actions><el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button></template>
			<el-form-item label="模块名称：">
						<el-input clearable v-model="formInline.menuName" size="small" placeholder="请输入模块名称" @keyup.enter.native="inputChange"></el-input>
					</el-form-item>
					<el-form-item label="模块编号：">
						<el-input clearable v-model="formInline.menuCode" size="small" placeholder="请输入模块编号" @keyup.enter.native="inputChange"></el-input>
					</el-form-item>
			</lcsj-filter>
				<!--列表-->
				<STable
					:columns="columnsData"
					:data="listData"
					:loading="loading"
					max-height="650"
					height="650"
					:row-key="'keyId'"
					:tree-props="{ children: 'subList', hasChildren: 'hasChildren' }"
					@get-data="getListData"
					@row-click="handleRowClick"
				>
					<template #menuIcon>
						<el-table-column align="center" prop="menuIcon" label="模块图标">
							<template #default="scope">
								<i v-if="scope.row.menuType === 3" :class="['al-iconfont', scope.row.menuIcon]"></i>
								<i v-else :class="scope.row.menuIcon"></i>
							</template>
						</el-table-column>
					</template>
					<template #menuType>
						<el-table-column align="center" label="模块类型" prop="menuType" min-width="80">
							<template #default="scope">
								<el-tag v-if="scope.row.menuType === 1" class="typeTag" type="primary">web</el-tag>
								<el-tag v-else-if="scope.row.menuType === 2" class="typeTag" type="info">客户端</el-tag>
								<el-tag v-else-if="scope.row.menuType === 3" class="typeTag" type="danger">手机端</el-tag>
								<el-tag v-else class="typeTag" type="warning">其他</el-tag>
							</template>
						</el-table-column>
					</template>
					<template #menuColor>
						<el-table-column align="center" label="颜色" prop="menuColor" min-width="80">
							<template #default="scope">
								<el-tag class="colorG" :color="scope.row.menuColor"></el-tag>
							</template>
						</el-table-column>
					</template>
					<template #isShow>
						<el-table-column align="center" prop="isShow" label="是否显示">
							<template #default="scope">
								<span @click.stop.prevent>
									<el-switch v-model="scope.row.isShow" active-color="#13ce66" inactive-color="" @change="editIsShow(scope.row)"></el-switch>
								</span>
							</template>
						</el-table-column>
					</template>
					<template #isOnLine>
						<el-table-column align="center" prop="isOnLine" label="是否上线">
							<template #default="scope">
								<span @click.stop.prevent>
									<el-switch v-model="scope.row.isOnLine" active-color="#13ce66" inactive-color="" @change="editIsOnLine(scope.row)"></el-switch>
								</span>
							</template>
						</el-table-column>
					</template>
					<template #handle>
						<el-table-column label="操作" align="center" width="150">
							<template #default="scope">
								<el-button v-if="scope.row.menuLevel !== 3" size="mini" type="" icon="el-icon-plus" @click.stop="addModule(scope.row)">新增</el-button>
							</template>
						</el-table-column>
					</template>
				</STable>
				<!-- 分页组件 -->
				<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
			</div>

		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 按钮 -->
		<editBtn ref="editBtn"></editBtn>
	</div>
</template>

<script>
import { GetMenuTreeList, SetMenuIsShow, SetMenuIsOnLine } from "../../../api/menuApi.js";
import edit from "./edit";
import editBtn from "./editBtn.vue";
export default {
	data() {
		return {
			tabData: [
				{
					key: "1",
					value: "Web端菜单"
				},
                { key: "3", value: "App端菜单" }
			],
			activePlatform: "1",
            requestId: 0,
            pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				menuName: "",
                menuCode: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "100",
					isKeep: true
				},
				{
					prop: "menuName",
					label: "模块名称",
					isKeep: true
				},
				{
					prop: "menuCode",
					label: "模块编号"
				},
				{
					prop: "menuPath",
					label: "模块地址"
				},
				{
					slot: "menuType",
					label: "模块类型"
				},
				{
					prop: "seq",
					label: "显示顺序"
				},
				{
					slot: "menuIcon",
					label: "模块图标"
				},
				{
					slot: "menuColor",
					label: "颜色"
				},
				{
					slot: "isShow",
					label: "是否显示"
				},
				{
					slot: "isOnLine",
					label: "是否上线"
				},
				{
					slot: "handle",
					isKeep: true,
					label: "操作"
				}
			]
		};
	},
	// 注册组件
	components: {
		edit,
		editBtn
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));

		this.getListData();
	},
	computed: {},
	methods: {
		switchPlatform(id) {
            this.activePlatform = id;
            this.listData = []; this.pageparm.total = 0; this.clearAll();
        },
        // 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row, 1, Number(this.activePlatform));
		},

		// 新增子菜单
		addModule(row) {
			if (row.menuLevel === 1) {
				this.$refs.edit.editShow(row, 2, Number(this.activePlatform));
			} else if (row.menuLevel === 2) {
				this.$refs.editBtn.editShow(row, "add");
			}
		},

		// 单击行数据
		handleRowClick(row) {
			if (row.menuLevel === 3) {
				this.$refs.editBtn.editShow(row, "edit");
			} else {
				this.$refs.edit.editShow(row, 1);
			}
		},

		// 设置是否显示
		editIsShow(row) {
			let param = {
				keyId: row.keyId,
				isUse: row.isShow
			};
			SetMenuIsShow(param)
				.then((res) => {
					if (res.code === 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						setTimeout(() => {
							this.getListData();
						}, 500);
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},

		// 设置是否上线
		editIsOnLine(row) {
			let param = {
				keyId: row.keyId,
				isUse: row.isOnLine
			};
			SetMenuIsOnLine(param)
				.then((res) => {
					if (res.code === 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						setTimeout(() => {
							this.getListData();
						}, 500);
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},

		handleCommand(command) {
			switch (command.command) {
				case "1":
					this.addModule(command.rowData);
					break;
				default:
					console.log(command);
			}
		},

		// 获取列表
		getListData() {
			this.loading = true;
			const requestId = ++this.requestId;
            GetMenuTreeList({ ...this.formInline, menuType: Number(this.activePlatform) })
				.then((res) => {
                    if (requestId !== this.requestId) return;
                    this.loading = false;
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					if (requestId !== this.requestId) return;
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},

		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped>
.colorG {
	width: 100%;
}

::v-deep .el-switch__core {
	width: 40px !important;
}
</style>
